import { render } from "./Counselor.vue?vue&type=template&id=1bef4f02&scoped=true"
import script from "./Counselor.vue?vue&type=script&lang=js"
export * from "./Counselor.vue?vue&type=script&lang=js"

import "./Counselor.vue?vue&type=style&index=0&id=1bef4f02&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-1bef4f02"

export default script